"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appBannerContainerStyle = exports.appNameContainerStyle = exports.descriptiveTextStyle = exports.helpTextStyle = exports.selectionNameStyle = exports.iconContainerStyle = exports.containerStyle = void 0;
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const theme_1 = require("@zapier/theme");
const DEFAULT_BORDER_COLOR = design_system_1.Colors.grey200;
const BORDER_RADIUS = `10px`;
const FOCUS_OR_HOVER_BOX_SHADOW = '0px 5px 10px rgba(0, 0, 0, 0.1)';
const FOCUS_OR_HOVER_TRANSITION = 'box-shadow 0.2s ease-in-out';
const border = (color) => `1px solid ${color ? design_system_1.Colors[color] : DEFAULT_BORDER_COLOR}`;
exports.containerStyle = ({ backgroundColor, borderColor, }) => core_1.css `
  background-color: ${backgroundColor ? design_system_1.Colors[backgroundColor] : ''};
  min-height: 60px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: ${theme_1.Spacing.medium}px;

  border-left: ${border(borderColor)};
  border-top: ${border(borderColor)};
  border-right: ${border(borderColor)};

  :first-of-type {
    border-top-left-radius: ${BORDER_RADIUS};
    border-top-right-radius: ${BORDER_RADIUS};
  }

  :last-of-type {
    border-bottom-left-radius: ${BORDER_RADIUS};
    border-bottom-right-radius: ${BORDER_RADIUS};
    border-bottom: ${border(borderColor)};
  }

  &:focus {
    box-shadow: ${FOCUS_OR_HOVER_BOX_SHADOW};
    transition: ${FOCUS_OR_HOVER_TRANSITION};
  }

  &:hover {
    box-shadow: ${FOCUS_OR_HOVER_BOX_SHADOW};
    transition: ${FOCUS_OR_HOVER_TRANSITION};
  }

  /* Enable the focus-specific pseudo element to be properly positioned */
  position: relative;

  /* Focus-specific pseudo-element to match ZDS focus outlines */
  &::before {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 2px;
    right: 2px;
    bottom: 2px;
    left: 2px;
    border: 2px solid transparent;
    transition-property: all;
    transition-timing-function: ${design_system_1.Animation.transitionTimingFunction};
    transition-duration: ${design_system_1.Animation.transitionDuration};
  }
  &:first-of-type::before {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  &:last-of-type::before {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  &:focus {
    &::before {
      border-color: ${design_system_1.Colors.blue500};
      top: -1px;
      right: -1px;
      bottom: 0px;
      left: -1px;
    }
  }
`;
exports.iconContainerStyle = core_1.css `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
`;
exports.selectionNameStyle = core_1.css `
  flex-grow: 1;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  min-width: 0;
`;
exports.helpTextStyle = core_1.css `
  line-height: 1.5;
`;
exports.descriptiveTextStyle = core_1.css `
  margin-left: 20px;
`;
exports.appNameContainerStyle = core_1.css `
  vertical-align: middle;
`;
exports.appBannerContainerStyle = core_1.css `
  margin-left: 10px;
`;
